var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKeyBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2929 2.29289C18.6834 1.90237 19.3164 1.90237 19.707 2.29289L20.707 3.29289C21.0975 3.68342 21.0975 4.31643 20.707 4.70696C20.3164 5.09748 19.6834 5.09748 19.2929 4.70696L18.2929 3.70696C17.9024 3.31643 17.9024 2.68342 18.2929 2.29289Z",
    fill: "#8492EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2929 1.29289C19.6834 0.902369 20.3164 0.902369 20.707 1.29289C21.0975 1.68342 21.0975 2.31643 20.707 2.70696L16.207 7.20696C15.8164 7.59748 15.1834 7.59748 14.7929 7.20696C14.4024 6.81643 14.4024 6.18342 14.7929 5.79289L19.2929 1.29289Z",
    fill: "#8492EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 19.4995C3.00012 18.5714 3.36912 17.6812 4.02539 17.0249C4.68175 16.3687 5.57185 15.9995 6.5 15.9995H19V7.89795C19 7.34566 19.4477 6.89795 20 6.89795C20.5523 6.89795 21 7.34566 21 7.89795V20.9995C21 21.5299 20.7891 22.0395 20.4141 22.4146C20.039 22.7895 19.5303 22.9995 19 22.9995H6.5C5.57187 22.9995 4.68174 22.6313 4.02539 21.9751C3.36901 21.3187 3 20.4278 3 19.4995ZM5 19.4995C5 19.8973 5.15815 20.2797 5.43945 20.561C5.72073 20.8422 6.1023 20.9995 6.5 20.9995H19V17.9995H6.5C6.10228 17.9995 5.72074 18.1578 5.43945 18.439C5.15825 18.7202 5.00012 19.1018 5 19.4995Z",
    fill: "#8492EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 19.5V4.5C3 3.57174 3.36901 2.68177 4.02539 2.02539C4.68177 1.36901 5.57174 1 6.5 1H14.3438C14.896 1 15.3438 1.44772 15.3438 2C15.3438 2.55228 14.896 3 14.3438 3H6.5C6.10218 3 5.72076 3.15815 5.43945 3.43945C5.15815 3.72076 5 4.10218 5 4.5V19.5C5 20.0523 4.55228 20.5 4 20.5C3.44772 20.5 3 20.0523 3 19.5Z",
    fill: "#8492EB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 8C15 7.44772 14.5523 7 14 7C13.4477 7 13 7.44772 13 8C13 8.55228 13.4477 9 14 9C14.5523 9 15 8.55228 15 8ZM17 8C17 9.65685 15.6569 11 14 11C12.3431 11 11 9.65685 11 8C11 6.34315 12.3431 5 14 5C15.6569 5 17 6.34315 17 8Z",
    fill: "#8492EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyBook);
export default __webpack_public_path__ + "static/media/keyBook.62aaac25d39eb186847235328de1ee61.svg";
export { ForwardRef as ReactComponent };